import React, { useState } from "react";
import {
  IonButton,
  IonContent,
  IonDatetime,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonToolbar,
  IonButtons,
  IonTitle,
} from "@ionic/react";

import { closeOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { selectFilterByDateModal } from "../../../store/MassNotification/selectors/selectFilterByDateModal";
import { selectCreatedAtFilter } from "../../../store/MassNotification/selectors/selectCreatedAtFilter";
import {
  setCreatedAtFilter,
  setFilterByDateModal,
  setUpdateList,
} from "../../../store/MassNotification";
import { findDocumentsTypes } from "../../../store/MassNotification/actions/findDocumentTypes";
import { findTotalPeople } from "../../../store/MassNotification/actions/findTotalPeople";

export const FilterCreatedAtSelector: React.FC = () => {
  const dispatch = useDispatch();

  const showModal = useSelector(selectFilterByDateModal);
  const createdAtFilter = useSelector(selectCreatedAtFilter);

  const today = new Date().toISOString();
  const [selectedFromDate, setSelectedFromDate] = useState<string>("");
  const [selectedToDate, setSelectedToDate] = useState<string>("");

  const initFormData = () => {
    if (!createdAtFilter.from || !createdAtFilter.to) {
      setSelectedFromDate("");
      setSelectedToDate("");
      return;
    }
    setSelectedFromDate(new Date(createdAtFilter.from).toISOString());
    setSelectedToDate(new Date(createdAtFilter.to).toISOString());
  };

  const handleSubmit = async () => {
    dispatch(
      setCreatedAtFilter({
        from: selectedFromDate ? new Date(selectedFromDate).getTime() : 0,
        to: selectedToDate ? new Date(selectedToDate).getTime() : 0,
      })
    );
    dispatch(setFilterByDateModal(false));
    dispatch(setUpdateList());
    dispatch(findDocumentsTypes());
    dispatch(findTotalPeople());
  };

  const handleRemoveDateTag = async () => {
    dispatch(
      setCreatedAtFilter({
        from: 0,
        to: 0,
      })
    );
    dispatch(setFilterByDateModal(false));
    dispatch(setUpdateList());
    dispatch(findDocumentsTypes());
    dispatch(findTotalPeople());
  };

  return (
    <IonModal
      isOpen={showModal}
      onWillPresent={initFormData}
      onDidDismiss={() => dispatch(setFilterByDateModal(false))}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>Filtrar por fecha</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => dispatch(setFilterByDateModal(false))}>
              <IonIcon icon={closeOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem>
          <IonLabel>Desde</IonLabel>
          <IonDatetime
            displayFormat="DD/MM/YYYY"
            placeholder="Seleccionar fecha"
            value={selectedFromDate}
            max={selectedToDate || today}
            cancelText="Cancelar"
            doneText="Confirmar"
            onIonChange={(e) => setSelectedFromDate(e.detail.value || "")}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Hasta</IonLabel>
          <IonDatetime
            displayFormat="DD/MM/YYYY"
            placeholder="Seleccionar fecha"
            value={selectedToDate}
            max={today}
            cancelText="Cancelar"
            doneText="Confirmar"
            onIonChange={(e) => setSelectedToDate(e.detail.value || "")}
          />
        </IonItem>
      </IonContent>
      <IonFooter>
        <IonToolbar color="light">
          <IonButtons slot="end">
            <IonButton
              color="danger"
              fill="solid"
              disabled={!selectedFromDate || !selectedToDate}
              onClick={handleRemoveDateTag}
            >
              Limpiar filtro
            </IonButton>
            <IonButton
              color="primary"
              fill="solid"
              disabled={!selectedFromDate || !selectedToDate}
              onClick={handleSubmit}
            >
              Aplicar filtro
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  );
};
